import styled from "styled-components";

export const GradeContainer = styled.div`
  margin-top: 3rem;

  .grade-tab-titulo {
    width: 100%;
    position: relative;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    align-items: center;
    color: ${(props) => props.theme.colors.tertiary};
    margin-bottom: 1rem;

    &::after {
      content: "";
      position: absolute;
      z-index: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2px;
      background-color: ${(props) => props.theme.colors.elements};
      border-radius: 50px;
    }

    .tab-texto {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      font-weight: bold;
      color: ${(props) => props.theme.colors.secondary};

      &::after {
        content: "";
        position: relative;
        z-index: 1;
        width: 100%;
        height: 2px;
        background-color: ${(props) => props.theme.colors.secondary};
        border-radius: 50px;
      }
    }
  }

  .grade-subtitulo {
    color: ${(props) => props.theme.colors.tertiary};
    margin-bottom: 2rem;
    text-align: left;
    padding: 1rem 0;
  }

  .grade-scroll {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 95rem;
    padding-bottom: 2rem;
  }

  .grade-header {
    display: flex;
    gap: 2rem;
    margin-bottom: 1rem;
    min-width: fit-content;

    .header-cell {
      width: 22rem;
      flex: 0 0 auto;
      color: ${(props) => props.theme.colors.tertiary};

      &.header-cell-lg {
        width: 28rem;
      }

      &.header-cell-sm {
        width: 20rem;
      }
    }

    .header-variacao {
      width: 22rem;
      flex: 0 0 auto;
    }

    .nova-lista {
      .mais {
        background-color: ${(props) => props.theme.colors.elements};
        color: ${(props) => props.theme.colors.tertiary};
        display: flex;
        gap: 10px;
        position: relative;
        justify-content: center;
        align-items: center;
        white-space: nowrap;
        border-radius: 32px;
        width: auto;
        height: 36px;
        cursor: pointer;
        padding: 8px 16px;
        @media (max-width: 768px) {
          height: 30px;
        }

        .plus {
          width: 18px;
          fill: ${(props) => props.theme.colors.primary};
          @media (max-width: 768px) {
            width: 14px;
          }
        }
      }
    }
  }

  .grade-row {
    display: flex;
    gap: 2rem;
    margin-bottom: 3.5rem;
    align-items: center;
    min-width: fit-content;

    .cell {
      width: 22rem;
      flex: 0 0 auto;
      position: relative;

      &.cell-lg {
        width: 28rem;
      }

      &.cell-sm {
        width: 20rem;
      }

      .inputComponentContainer {
        width: 100%;
      }

      .replicar {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        cursor: default;
        bottom: -3rem;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.3s ease;
        svg {
          margin-right: 1rem;
        }
        &.visible {
          cursor: pointer;
          opacity: 1;
          pointer-events: auto;
        }
      }

      .conversor-peso {
        position: absolute;
        top: 105%;
        left: 2rem;
        font-size: 1.8rem;
        color: ${(props) => props.theme.colors.placeholder};
        transition: opacity 0.3s ease;
      }

      .replicar.visible ~ .conversor-peso {
        opacity: 0;
        pointer-events: none;
      }
    }

    .cell-variacao {
      width: 22rem;
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      color: ${(props) => props.theme.colors.secondary};
      background: ${(props) => props.theme.colors.elements};
      border-radius: 8px;
      padding: 1.2rem 1.6rem;
      min-height: 4.8rem;
      word-break: break-word;
      white-space: normal;
    }

    .cell-delete {
      cursor: pointer;
      padding: 1rem;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      span {
        position: absolute;
        width: 1.5rem;
        height: 2px;
        border-radius: 5rem;
        background-color: ${(props) => props.theme.colors.tertiary};
        transition: transform 0.25s ease, background-color 0.25s ease;
      }

      &:hover span {
        background-color: white;

        &:first-child {
          transform: rotate(45deg);
        }
        &:last-child {
          transform: rotate(-45deg);
        }
      }
    }
  }

  .grade-footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 2rem;

    .restaurar {
      display: flex;
      height: 33px;
      padding: 8px 16px;
      justify-content: center;
      align-items: center;
      gap: 8px;
      border-radius: 30px;
      background-color: ${(props) => props.theme.colors.elements};
      color: ${(props) => props.theme.colors.tertiary};
      cursor: pointer;

      svg {
        width: 20px;
        height: 20px;
        color: ${(props) => props.theme.colors.primary};
        transition: transform 0.6s ease;
      }

      &.spinning svg {
        animation: spin 0.6s ease;
      }
    }
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(-360deg);
    }
  }
`;
